import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {AppService} from "@api";
import {AsignacionAlumnoModal} from "@contenido/AppContent/global/asignacionalumno/asignacionalumno.component";
import {ColaboradorEvaluacionModalComponent} from "@contenido/AppContent/global/colaboradorevaluacion/colaboradorevaluacion.component";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum, DialogoEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import { EvaluacionAlumno } from "@modelo/global/EvaluacionAlumno.model";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";


@Component({
    selector: 'asignacionevaluacionalumnos_colaboradores',
    templateUrl: './asignacionevaluacionalumno_colaborador.component.html',
    styleUrls: ['./asignacionevaluacionalumno_colaborador.component.scss']
})

export class AsignacionEvaluacionAlmunosColaboradoresComponent implements AfterViewInit {
    consulta!:boolean;
    @Input() nivel!: string;
    @Input() nivelid!: number;
    @Input() cicloid!: number;
    @Input() periodoevaluacionid!: number;
    @Input() periodoevaluacionportipoevaluacionid!: number;
    @Input() tipoevaluacionid!: number;
    @Input() identificador!: number;
    @Output() prevista = new EventEmitter();
    @ViewChild('colaborador') private colaborador!: ColaboradorEvaluacionModalComponent;

    @ViewChild('asignacionalumno') private asignacionalumno!: AsignacionAlumnoModal;

    listacolaborador: any[];
    colaboradorguardar: any[];
    Dataalumnocolaborador: any[];

    colaboradores:any[] = [];
    listagrados: any[] = [];

    visualizar: boolean = false;

    colaboradorid: number = 0;

    entidadcolaborador:any;

    gradoid: number = 0;

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {

        this.listacolaborador = [];
        this.colaboradorguardar = [];
        this.Dataalumnocolaborador = [];
    }

    ngAfterViewInit() {
        if (this.identificador == 2) {
            this.visualizar = true;
        }
        this.SetAlumnoColaborador();
    }

    onInitialized(e: any) {
        e.component.columnOption("command:expand", "width", 20);
    }

    onRowPrepared(e: any) {
        if (e.rowType === "group" && e.groupIndex == 0) {
            let grupos:any[] = e.data.items ? e.data.items : e.data.collapsedItems;
            let total = grupos.reduce((accumulator, currentValue) =>
                accumulator + (currentValue.items ? currentValue.items : currentValue.collapsedItems as any[]).length, 0);
            e.data.total = total;
        }
    }

    GuardarColaborador(entidad: any) {
        this.colaboradorguardar = entidad;
        this.asignacionalumno.listacolaboradores = [];
        this.asignacionalumno.listacolaboradores = entidad;
        this.asignacionalumno.periodoevaluacionportipoevaluacionid = this.periodoevaluacionportipoevaluacionid;
        this.asignacionalumno.Modal();
    }

    GuardarAlumno(listaalumnos: any) {
        if (listaalumnos.length > 0) {
            this.appService.Post("planeacion/asignacionevaluacion/alumno/alumnocolaboradorguardar", {"listacolaborador": this.colaboradorguardar, "listaalumnos": listaalumnos, "periodoevaluacionid": this.periodoevaluacionid,"tipoevaluacionid":this.tipoevaluacionid ,"nivelid": this.nivelid, "cicloid": this.cicloid, "periodoevaluacionportipoevaluacionid": this.periodoevaluacionportipoevaluacionid}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.asignacionalumno.listacolaboradores = [];
                    if (this.listacolaborador.length == 0) {
                        this.listacolaborador = this.colaboradorguardar;
                    } else {
                        for (let col of this.colaboradorguardar) {
                            this.listacolaborador.push(col);
                        }
                    }
                    this.colaboradorguardar = [];
                    this.asignacionalumno.periodoevaluacionportipoevaluacionid = 0;
                    this.colaborador.CerrarModal();
                    this.asignacionalumno.CerrarModal();
                    this.SetAlumnoColaborador();
                }
            })
        }
    }

    SetAlumnoColaborador() {
        this.appService.Post("planeacion/asignacionevaluacion/alumno/alumnocolaborador", {"periodoevaluacionid": this.periodoevaluacionid, "nivelid": this.nivelid, "cicloid": this.cicloid, "periodoevaluacionportipoevaluacionid": this.periodoevaluacionportipoevaluacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.Dataalumnocolaborador = res.data.lista;
                if (this.listacolaborador.length == 0) {
                  this.listacolaborador = res.data.listacolaborador;
                }
                this.colaboradores = res.data.listacolaboradorpre;
                this.listagrados = [];
                this.gradoid = 0;
                this.colaboradorid = 0;
            }
        })
    }

    getGrado(asignacionevaluacionalumnoporcolaboradorid:any){
      this.listagrados = [];
      this.gradoid = 0;
      if(asignacionevaluacionalumnoporcolaboradorid){
        this.entidadcolaborador = this.colaboradores.find(x=>x.asignacionevaluacionalumnoporcolaboradorid == asignacionevaluacionalumnoporcolaboradorid);
        this.appService.Post("planeacion/asignacionevaluacion/alumno/alumnodetalle",this.entidadcolaborador).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
            this.listagrados = res.data
          }
        })
      }
    }

    Eliminar(e: any) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                let valor = [];
                if (e.data.items) {
                    if (e.data.items[0].items) {
                        valor = e.data.items[0].items[0];
                    } else if (e.data.items[0].collapsedItems) {
                        valor = e.data.items[0].collapsedItems[0];
                    }
                }
                else if (e.data.collapsedItems) {
                    if (e.data.collapsedItems[0].items) {
                        valor = e.data.collapsedItems[0].items[0];

                    } else if (e.data.collapsedItems[0].collapsedItems) {
                        valor = e.data.collapsedItems[0].collapsedItems[0];

                    }
                }
                this.appService.Delete("planeacion/asignacionevaluacion/alumno/alumnocolaborador/eliminar/" + valor.asignacionevaluacionalumnoporcolaboradorid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.SetAlumnoColaborador();
                        this.listacolaborador = [];
                    }
                })
            }
        })
    }

    EliminarGrado(e: any) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                let valor = [];
                if (e.data.items) {
                    valor = e.data.items[0];
                }
                else if (e.data.collapsedItems) {
                    valor = e.data.collapsedItems[0];
                }
                this.appService.Post("planeacion/asignacionevaluacion/alumno/alumnocolaboradorporgrupo/eliminar", {"entidad": valor, "periodoevaluacionid": this.periodoevaluacionid, "periodoevaluacionportipoevaluacionid": this.periodoevaluacionportipoevaluacionid, "nivelid": this.nivelid, "cicloid": this.cicloid}).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.listacolaborador = [];
                        this.SetAlumnoColaborador();
                    }
                })


            }
        })
    }

    Formulario(e: any) {
        let valor = [];
        if (e.data.items) {
            if (e.data.items[0].items) {
                valor = e.data.items[0].items[0];
            } else if (e.data.items[0].collapsedItems) {
                valor = e.data.items[0].collapsedItems[0];
            }
        }
        else if (e.data.collapsedItems) {
            if (e.data.collapsedItems[0].items) {
                valor = e.data.collapsedItems[0].items[0];

            } else if (e.data.collapsedItems[0].collapsedItems) {
                valor = e.data.collapsedItems[0].collapsedItems[0];

            }
        }
        let colaborador = {"colaboradorid": valor.colaboradorid, "nombreypuesto": valor.colaborador, "puestoid": valor.puestoid, "asignacionevaluacionalumnoporcolaboradorid": valor.asignacionevaluacionalumnoporcolaboradorid};
        this.appService.Post("planeacion/asignacionevaluacion/alumno/alumnocolaborador", {"periodoevaluacionid": this.periodoevaluacionid, "nivelid": this.nivelid, "cicloid": this.cicloid, "colaboradorid": valor.colaboradorid, "puestoid": valor.puestoid, "periodoevaluacionportipoevaluacionid": this.periodoevaluacionportipoevaluacionid}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.asignacionalumno.listacolaboradores = [];
                this.colaboradorguardar.push(colaborador);
                this.asignacionalumno.listacolaboradores.push(colaborador);
                this.asignacionalumno.periodoevaluacionportipoevaluacionid = this.periodoevaluacionportipoevaluacionid;
                this.asignacionalumno.Editar(res.data.lista);
            }
        })

    }

    Modal() {
        this.colaborador.listcolaboradorduplicado = this.listacolaborador;
        this.colaborador.seleccionMultiple = true;
        this.colaborador.colaboradorconpuesto = 1;
        this.colaborador.nivel = this.nivel;
        this.colaborador.Modal()
    }

    preevisualizar(e:any){
      if(e){
        let entidad = this.listagrados.find(x=>x.gradoid == e);
          this.appService.Post("planeacion/asignacionevaluacion/tipovisualizacion",{"gradoid": entidad.gradoid,"evaluadorid":[3,4]}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
              let visual = res.data;
              let val = new EvaluacionAlumno();
              val.gradoid = entidad.gradoid;
              val.nivelid = this.entidadcolaborador.nivelid;
              val.puestoid = this.entidadcolaborador.puestoid;
              val.tipoplantillaid = 3;
              val.tipovisualizacioncompetenciacriterioid = visual[0].tipovisualizacioncompetenciacriterioid;
              val.tipovisualizacionpreguntaid = visual[0].tipovisualizacionpreguntaid;
              val.tipovisualizacionrespuestaid = visual[0].tipovisualizacionrespuestaid;
              val.evaluadorid = visual[0].evaluadorid;
              this.prevista.next(val);
            }
          })
      }
  }

  }
